'use client';

import React, { useEffect, useState } from 'react';
import InitialPopUp from '../InitialPopUp';

export default function LayoutPopUp() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    const isOpenModal = window.localStorage.getItem('initialPopUp');

    if (isOpenModal === 'true') {
      setTimeout(() => {
        setIsModalOpen(true);
        setTimeout(() => setStartAnimation(true), 100);
      }, 2000);
    }
  }, []);

  const handleClose = () => {
    setIsModalOpen(false);
    window.localStorage.setItem('initialPopUp', 'false');
  };

  const handleSubmit = () => {
    handleClose();
  };
  return (
    <InitialPopUp
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      startAnimation={startAnimation}
      setStartAnimation={setStartAnimation}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
}
